<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search-list-change="searchListChange"
            searchId="pilot-vehicle-switch"
            pageID="pilot-vehicle-switch"
        >
            <template #table-module-btn>
                <report-export #default="{ submit }" reportCode="PILOT_VEHICLE_CONFIG_EXPORT">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <el-button
                            icon="icon-daochu"
                            size="mini"
                            @click="exportFile(submit)"
                            v-has="'/distribute/pilot-vehicle-switch/page/export'"
                        ></el-button>
                    </el-tooltip>
                </report-export>
            </template>
            <template #page-module-btn>
                <el-button type="primary" @click="handleBatchDelete" v-has="'/distribute/pilot-vehicle-switch/page/delete'">删除</el-button>
                <el-button type="primary" v-has="'/distribute/pilot-vehicle-switch/page/import'" @click="chcImportC"
                    >长合车计费变革导入</el-button
                >
                <el-button type="primary" v-has="'/distribute/pilot-vehicle-switch/page/import'"  @click="algorithmicImportC">算法排车计费变革导入</el-button>
            </template>
        </m-pane>
        <Import2 ref="chcImport" :ImportConfig="config.ImportConfig" :ImportContent="config.ImportContent" @reflashList="getList"> </Import2>
        <Import2 ref="algorithmicImport" :ImportConfig="config.algorithmicImportConfig" :ImportContent="config.algorithmicImportContent" @reflashList="getList"></Import2>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import config from './config.js';
import Import2 from './components/import2';
import { pilotVehicleSwitchPage, batchDeleteByIdList } from '@/modules/otp/api/pilotVehicleSwitch.js';
import { dictWithUrl } from '@/components/lots/api.js';
import reportExport from '@/components/lots/reportExportPlugin';
import dayjs from 'dayjs';
export default {
    name: 'pilotVehicleSwitch',
    components: {
        paper,
        mPane,
        reportExport,
        Import2
    },

    data () {
        return {
            config,
            loading: false,
            selectedList: [],
            totalData: [],
            pageTotal: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                siteCodeList: [],
                carrierCodeList: [],
                companyCodeList: [],
                // 批次号
                batchNum: '',
                vehicleCard: '',
                // 导入时间起
                createTimeStart: '',
                // 导入时间止
                createTimeEnd: '',
                createTime: ''
            },
            isFirstSearch: true
        };
    },
    computed: {
    },
    methods: {
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                ...data
            };
            this.searchParams = this.formatSearchData(_searchData);
            const isQueryOk = this.validateSearchData(this.searchParams);
            if (!isQueryOk) return;
            this.getList();
            this.isFirstSearch = false;
        },
        searchListChange (prop, data) {
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                // beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                // endDate: '2030-07-26 00:00:00',
                ...this.searchParams,
                createTimeStart: this.searchParams.createTimeStart || '2010-07-26 00:00:00',
                createTimeEnd: this.searchParams.createTimeEnd || '2030-07-26 00:00:00'
            });
            this.isFirstSearch = false;
        },
        // 批量删除
        async handleBatchDelete (data) {
            if (!this.selectedList.length) return this.$message.warning('请勾选需要删除的数据!');
            await this.$confirm('此操作将删除选中数据，请确认是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            const ids = this.selectedList.map(i => i.id);
            batchDeleteByIdList(ids).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList();
                }
            });
        },
        formatSearchData (data) {
            const params = JSON.parse(JSON.stringify(data));
            params.createTimeStart = params.createTime ? dayjs(params.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
            params.createTimeEnd = params.createTime ? dayjs(params.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';

            params.companyCodeList = params.companyCode ? params.companyCode.split(',') : [];
            params.siteCodeList = params.siteCode ? params.siteCode.split(',') : [];
            params.carrierCodeList = params.carrierCode ? params.carrierCode.split(',') : [];
            delete params.createTime;
            delete params.companyNameList;
            delete params.siteNameList;
            delete params.carrierNameList;
            return params;
        },
        /**
        * @description 校验查询时间跨度不能超过指定日期
        * @param {Object} searchData 查询参数
        * @param {String} sDateField 查询起始时间字段名
        * @param {String} eDateField 查询结束时间字段名
        */
        validateMaxDate (searchData, sDateField, eDateField) {
            if (searchData[sDateField] && searchData[eDateField]) {
                const sDateTimeStamp = new Date(searchData[sDateField]).getTime();
                const eDateTimeStamp = new Date(searchData[eDateField]).getTime();
                const maxDay = 1000 * 60 * 60 * 24 * 94; // 按31天来算，组件问题，得加多一天
                if (eDateTimeStamp - sDateTimeStamp > maxDay) {
                    this.$message.warning('按时间查询或导出时，查询或导出时间跨度不可超过三个月');
                    return false;
                }
            } else {
                if (this.searchParams.companyCodeList.length > 0) {
                    this.$message.warning('分公司选择后需要选择查询时间');
                    return false;
                }
            }
            return true;
        },
        validateSearchData (searchData) {
            return this.validateMaxDate(searchData, 'createTimeStart', 'createTimeEnd');
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        async getList () {
            this.loading = true;
            // 去除name
            const params = {
                ...this.searchParams
            };
            try {
                const res = await pilotVehicleSwitchPage(params);
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data;
                    this.totalData = list || [];
                    this.totalData.forEach(v => {
                        v.taskStatusCn = `${v.taskStatus || v.taskStatus === 0 ? v.taskStatus : ''}`;
                        v.importType = (v.importType !== undefined && v.importType !== null) ? `${v.importType}` : v.importType;
                    });
                    this.pageTotal = totalCount;
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        // 获取下载模板路径
        async getDictList () {
            if (!this.config.ImportContent[0].downLoadInfo.url) {
                const dict = await dictWithUrl('ANNTO_FORMWORK_OTP');
                this.config.ImportContent[0].downLoadInfo.url =
                    dict.data.ANNTO_FORMWORK_OTP.PILOT_VEHICLE_CONFIGURATION_IMPORT;
                this.config.algorithmicImportContent[0].downLoadInfo.url =
                    dict.data.ANNTO_FORMWORK_OTP.ALGORITHM_DISPATCH_PILOT_IMPORT;
            }
        },
        // 导入
        chcImportC () {
            this.getDictList();
            this.$refs.chcImport.orderImportC();
        },
        algorithmicImportC () {
            this.getDictList();
            this.$refs.algorithmicImport.orderImportC();
        },
        // 选中表格行
        selectChange (data) {
            this.selectedList = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    },
    async mounted () {
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    }
};
</script>

<style lang='less' scoped>
</style>
